<template>
  <vs-popup class=""
            id="popup"
            title="CREATE RAW MATERIAL"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(openSaveConfirm)" autocomplete="off">


          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full">
              <ValidationProvider vid="manufacturing_site" name="manufacturing_site" rules="required" v-slot="{ errors }">
                <small class="label">Manufacturing Sites</small>
                <v-select multiple  :clearable="false" name="manufacturing_site" placeholder="" label="site_name" v-model="form.manufacturing_site" :reduce="option => option.id" :options="sites" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template v-slot:option="option">
                    <span>{{option.site_name}} </span>
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3 hidden">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="similar_raw_materials" name="similar_raw_materials" rules="" v-slot="{ errors }">
                <small class="label">Similar RM</small>
                <v-select
                  @search="onSearch"
                  :clearable="false" multiple name="formulation_items" placeholder=""
                  label="company_product_code" v-model="form.similar_raw_materials" :reduce="option => option"
                  :options="similar_rms" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template slot="no-options">
                    type to search products
                  </template>
                  <template slot="option" slot-scope="option">
                    <div class="d-center">
                      <span>PRODUCT CODE: <strong>{{ option.company_product_code || '-' }}</strong></span> <br>
                      <small>PRODUCT NAME : <strong>{{ option.company_product_name || '-' }}</strong></small> <br>
<!--                      <small>Supplier prod name : <strong>{{ option.supplier_product_name }}</strong></small> <br>-->
                    </div>
                  </template>
                  <template slot="selected-option" slot-scope="option">
                    <div class="selected d-center">
                      {{ option.company_product_code }}
                    </div>
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="supplier_product_code" name="supplier_product_code" rules="required" v-slot="{ errors }">
                <small class="label">Supplier Product Code</small>
                <vs-input v-model="form.supplier_product_code" name="supplier_product_code"  class="w-full required" label=""  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>

              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="supplier_product_name" name="supplier_product_name" rules="required" v-slot="{ errors }">
                <small class="label">Supplier Product Name</small>
                <vs-input name="supplier_product_name" v-model="form.supplier_product_name"  class="w-full required" label=""  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>

              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">

            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="alternative_chemical_name" name="alternative_chemical_name" rules="" v-slot="{ errors }">
                <small class="label">Alternative / Chemical Name</small>
                <vs-input name="alternative_chemical_name" v-model="form.alternative_chemical_name"  class="w-full required" label="" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <ValidationProvider vid="country_processing" name="country_processing" rules="required" v-slot="{ errors }">
                <small class="label">Country of Processing</small>
                <v-select :filter-by="myFilter" multiple :clearable="false" name="country_processing" placeholder="" label="name" v-model="form.country_processing" :reduce="option => option.id" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template v-slot:option="option">
                    <span>{{option.name}} </span>
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="row mb-3">
            <div class="vx-col md:w-ful w-full md:mb-0">
              <ValidationProvider vid="raw_material_stage" name="raw_material_stage" rules="required" v-slot="{ errors }">
                <small class="label">Stage (development,production)</small>
                <v-select name="raw_material_stage" :closeOnSelect="true" v-model="form.raw_material_stage" :options="['production', 'development']" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 md:mb-0">
              <ValidationProvider vid="is_food_grade" name="is_food_grade" rules="" v-slot="{ errors }">
                <small class="label">Food Grade?</small>
                <vs-switch v-model="form.is_food_grade" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                  <span slot="on">Yes</span>
                  <span slot="off">No</span>
                </vs-switch>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider v-if="form.is_food_grade" vid="is_food_grade_comment" name="is_food_grade_comment" rules="required" v-slot="{ errors }">
                <small class="label">If yes,please specify</small>
                <vs-input type="text" name="is_food_grade_comment" class="w-full" v-model="form.is_food_grade_comment" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 md:mb-0">
              <ValidationProvider vid="is_compliant_food_law" name="is_compliant_food_law" rules="" v-slot="{ errors }">
                <small class="label">Compliant with General Food Law (Regulation (EC) No 178/2002)</small>
                <vs-switch v-model="form.is_compliant_food_law" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                  <span slot="on">Yes</span>
                  <span slot="off">No</span>
                </vs-switch>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider v-if="form.is_compliant_food_law" vid="is_compliant_food_law_comment" name="is_compliant_food_law_comment" rules="required" v-slot="{ errors }">
                <small class="label">If yes,please specify</small>
                <vs-input type="text" name="is_compliant_food_law_comment" class="w-full" v-model="form.is_compliant_food_law_comment" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <small class="label">Additional Information</small>
              <vs-textarea v-model="form.additional_information" />
            </div>
          </div>
          <div class="flex flex-wrap items-center justify-end">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <!--          <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>-->
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SupplierRepository = RepositoryFactory.get('supplier')
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial')
  const DropDownRepository = RepositoryFactory.get('drop_down')

  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      media: '',
      isImage: '',
      isVideo: '',
      title :'',
      nodata: false,
      isNote:'',
      note:'',
      createForm: {},
      form: {
        is_food_grade:  false,
        is_compliant_food_law: false
      },
      countryCodes: [],
      sites: [],
      supplierId: '',
      similar_rms: []
    }
  }

export default {
  name: 'CreateRawMaterialPopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup (supplierId) {
      try {
        await Object.assign(this.$data, initialState())
        this.$vs.loading()
        this.supplierId = supplierId
        await this.loadCountrCode()
        // await this.getSimilarRmList()
        await this.loadManufacturingSites()
        this.open = true;
        this.$vs.loading.close()
      } catch (error) {
        this.$vs.loading.close()

      }
    },
    openSaveConfirm() {
      this.open = false
      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: 'Note',
        text: 'Once you save this page the supplier product code and name cannot be changed',
        accept: this.onClickUpdate,
        cancel: this.closeUpdate
      })
    },
    closeUpdate() {
      this.open = true
    },
    async onClickUpdate () {
      const vue = this;
      this.$vs.loading()
       try {
        this.form.supplier_id = this.supplierId

         const payload = this.form
         // if (payload.similar_raw_materials.length > 0) {
         //   payload.similar_raw_materials =  payload.similar_raw_materials.map((n) => n.id)
         // } else {
         //   payload.similar_raw_materials =  []
         // }

         await SupplierRawMaterialRepository.createRawMaterial(payload)
         this.showSuccessMessage('Raw material created successfully')
         await vue.$parent.refreshData()
         this.open = false;
       }catch (e) {
         this.$vs.loading.close()
         this.convertAndNotifyError(e)
       }
      this.$vs.loading.close()
    },
    async loadCountrCode() {
      const {data} =  (await SupplierManufactureRepository.getCountryCodes()).data
      this.countryCodes =  data
    },
    myFilter: (option, label, search) => {
      let temp = search.toLowerCase();
      return option.name.toLowerCase().indexOf(temp) > -1 ||
        option.isd_code.toLowerCase().indexOf(temp) > -1
    },
    async loadManufacturingSites() {
      this.$vs.loading()
      try {
        const {data} = await DropDownRepository.getManufacturingSites(this.supplierId, this.filterQuery)
        this.sites =  data.data
        this.meta = data.meta
      } catch (e) {

      }
      this.$vs.loading.close()
    },
    async getSimilarRmList() {
      try {
        const {data} = await SupplierRawMaterialRepository.getRawMaterialList(1, '', 100, '')
        this.similar_rms =  data.data
      } catch (e) {

      }
    },
    onSearch(search, loading) {
      if(search.length) {
        loading(true);
        this.search(loading, search, this);
      }
    },
    search: _.debounce( async (loading, search, vm) => {
      const {data} = await SupplierRawMaterialRepository.getRawMaterialList(1, `filter[search]=${search}`, 50, '')
      vm.similar_rms = data.data
      loading(false);
    }, 350)
  },
  async mounted () {

  },
  components: {
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .video-wrapper {
    width: 100%;
    height: 100%;
  }

  .video-wrapper video {
    object-fit: cover;
    width: 100%;
    height: 100%;

  }
  .image-wrapper {
    width: 100%;
    height: 75%;
  }


</style>
